import { useLayoutEffect } from 'react';
import { hasSelectedText } from '../utils/selection.js';

/**
 * Inputs are typically automatically selected when focused, such as when being tabbed to.
 * However, selection doesn't happen for the `autoFocus` prop, so we add that behavior here.
 */
function useSelectOnAutoFocus(ref, autoFocus) {
    useLayoutEffect(() => {
        if (autoFocus && !hasSelectedText(ref.current)) {
            // This is the default behavior, but for some reason does not happen if the input
            // uses `autoFocus`, so we need to do it manually.
            ref.current.select();
        }
        // We don't want to react to `autoFocus` being set as this prop should
        // generally be set to a static value. And we can expect the passed in `ref` to be stable.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export { useSelectOnAutoFocus };
//# sourceMappingURL=input-primitive.hooks.js.map
